import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { ButtonComponent } from "wecheer-common";

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    imports: [
      ButtonComponent,
      MatDialogModule,
    ],

})
export class MessageDialogComponent {
  dialogRef = inject<MatDialogRef<MessageDialogComponent, boolean>>(MatDialogRef);
  data = inject<MessageDialogComponent>(MAT_DIALOG_DATA);


  title: string;
  message: string;

  constructor() {
    const data = this.data;


    this.title = 'Info';
    this.message = data.message;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

/**
 * Class to represent confirm dialog model.
 * It has been kept here to keep it as part of shared component.
 */
export class MessageDialogModel {
  constructor(public message: string) {}

  async show(dialog: MatDialog): Promise<boolean> {

    const config: MatDialogConfig<MessageDialogModel> = {
      height: '220px',
      width: '450px',
      data: this
    };

    const result = await lastValueFrom(dialog
      .open(MessageDialogComponent, config)
      .afterClosed());

      return result;
  }

}
